/**
 * Default LLM model IDs (OpenRouter-style). Single source of truth for Korvo app and portal-sdk.
 * @module @korvo/portal-sdk/config/default-models
 */

/** Default model for main chat, portal (Mistral direct). */
export const DEFAULT_PORTAL_MODEL = 'mistral-small-latest';

/** Default model for summary, title, query/helper agents (light tasks). */
export const DEFAULT_SUMMARY_TITLE_MODEL = 'mistral-small-latest';

/** Default model for editor merger (document section merging). */
export const DEFAULT_EDITOR_MERGER_MODEL = 'mistral-small-latest';

/**
 * Cheapest Mistral model for live/CI testing (March 2026).
 * open-mistral-nemo-2407: Nemo 12B, ~$0.15/M tokens (Mistral API id; use this exact string).
 * Use PORTAL_LIVE_TEST_MISTRAL_MODEL to override (e.g. mistral-small-latest for tool calling).
 */
export const DEFAULT_CHEAP_TEST_MISTRAL_MODEL = 'open-mistral-nemo-2407';

/**
 * Capable Mistral model for live tests (tool schemas, tool_choice). Same as default portal model.
 * Run in addition to cheap model so provider-live.test.ts covers tools and schema handling.
 */
export const DEFAULT_CAPABLE_TEST_MISTRAL_MODEL = 'mistral-small-latest';
